import axios from '@/plugins/axios.js'

export default {
    postDeal(payload) {
        return axios.post('deals/create', payload)
    },
    getDeals() {
        return axios.get('deals')
    }
}